import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  marginTop: '1x',
  marginBottom: '1x',

  // The next sibling is the first Module, whose article has paddingTop: 4x (32px).
  // On mobile, zero that out so the total visible gap from the trust signal to the
  // price is exactly 1x (8px) — provided by this element's marginBottom.
  '& + div > article:first-of-type': {
    paddingTop: 0,
  },
  md: {
    // Desktop: the first Module's 4x top padding already provides enough space
    // between the trust signal and the price; don't stack a margin on top.
    marginBottom: 0,
    '& + div > article:first-of-type': {
      paddingTop: '4x',
    },
  },
});

export const trustSignalText = css({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  margin: 0,
  color: 'hpxGrey600',
  fontSize: 'tiny',
  lineHeight: '16px',
  letterSpacing: '0.3px',
  md: {
    fontSize: '13px',
    lineHeight: '18px',
  },
});

export const trustSignalSegment = css({
  display: 'flex',
  alignItems: 'center',
});

export const trustSignalSeparator = css({
  color: 'hpxGrey400',
  marginX: '6px',
});
